import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
      }}
    >
      <Box
        sx={{
          maxWidth: "1440px",
          px: "100px",
          py: "56px",
          "@media (max-width: 1360px)": {
            px: "16px",
            py: "32px",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            p: "48px",
            "@media (max-width: 1024px)": {
              p: "36px",
            },
            "@media (max-width: 856px)": {
              p: "16px",
            },
          }}
        >
          {/* Main Title */}
          <Typography
            sx={{
              fontSize: "36px",
              fontWeight: "700",
              color: "#333",
              mb: 4,
              lineHeight: 1.2,
            }}
          >
            Cookie Policy
          </Typography>

          {/* Introduction */}
          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            Please read this cookie policy ("cookie policy", "policy") carefully before using the R3PLAY.com website ("website", "service") operated by R3PLAY LLC ("us", "we", "our").
          </Typography>

          {/* What are cookies Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            What are cookies?
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            Cookies are simple text files that are stored on your computer or mobile device by a website's server. Each cookie is unique to your web browser. It will contain some anonymous information such as a unique identifier, website's domain name, and some digits and numbers.
          </Typography>

          {/* What types of cookies Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
              letterSpacing: "-0.02em"
            }}
          >
            What types of cookies do we use?
          </Typography>

          {/* Necessary Cookies */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Necessary Cookies
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            Necessary Cookies allow us to offer you the best possible experience when accessing and navigating through our website and using its features. For example, these cookies let us recognize that you have created an account and have logged into that account.
          </Typography>

          {/* Functionality Cookies */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Functionality Cookies
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            Functionality Cookies let us operate the site in accordance with the choices you make. For example, we will recognize your username and remember how you customized the site during future visits.
          </Typography>

          {/* Analytical Cookies */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Analytical Cookies
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            These cookies enable us and third-party services to collect aggregated data for statistical purposes on how our visitors use the website. These cookies do not contain personal information such as names and email addresses and are used to help us improve your user experience of the website.
          </Typography>

          {/* How to delete cookies Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            How to delete cookies?
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            If you want to restrict or block the cookies that are set by our website, you can do so through your browser setting. Alternatively, you can visit https://internetcookies.com, which contains comprehensive information on how to do this on a wide variety of browsers and devices. You will find general information about cookies and details on how to delete cookies from your device.
          </Typography>

          {/* Contacting Us Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Contacting Us
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 2,
              lineHeight: 1.6,
            }}
          >
            If you have any questions about this policy or our use of cookies, please contact us at{" "}
            <Typography
              component="span"
              sx={{
                color: "#EF5658",
                fontWeight: "500",
              }}
            >
              letsplay@r3play.com
            </Typography>
            .
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CookiePolicy;
